import { render, staticRenderFns } from "./machineryEventsTable.vue?vue&type=template&id=21230f84"
import script from "./machineryEventsTable.vue?vue&type=script&lang=ts"
export * from "./machineryEventsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports